import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { Stakes } from '../components/Stakes';
import { ProductLoop } from '../components/ProductLoop';
import { CreatorLab } from '../components/CreatorLab';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-navy-950 text-slate-300 font-sans selection:bg-electric selection:text-white" data-id="element-175">
      <Navbar data-id="element-176" />
      <main data-id="element-177">
        <Hero data-id="element-178" />
        <Stakes data-id="element-179" />
        <ProductLoop data-id="element-180" />
        <CreatorLab data-id="element-181" />
      </main>
      <Footer data-id="element-182" />
    </div>;
}